import { useEffect, useRef, useState } from "react";
import { Box, Button, Card, Slider, Typography } from "@mui/material";
import ReactPlayer from "react-player";
import {
  CalendarMonth,
  PauseCircleFilledOutlined,
  PlayCircleFilledOutlined,
  SwapHorizOutlined,
  TimerOutlined,
  VolumeMuteOutlined,
  VolumeOffOutlined,
} from "@mui/icons-material";
import HLSPlayer from "./HLSPlayer";

export default function KeyMoments(props) {
  const { segmentDetails, keyMoments, videoUrl } = props;

  const [isExpanded, setIsExpanded] = useState(false);
  const [currentKeyMoment, setCurrentKeyMoment] = useState(null);

  const [sliderValue, setSliderValue] = useState([]);
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);

  const [playing, setPlaying] = useState(false);
  const [mute, setMute] = useState(false);
  const [playtime, setPlaytime] = useState(0);

  const formattedDate = (timestamp) => {
    const result = new Date(timestamp).toLocaleString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
    });
    return result;
  };

  const handleRangeSlider = (event, newValue) => {
    setPlaying(false);
    setSliderValue(newValue);
    setStartTime(newValue[0] + segmentDetails?.video_start_time / 1000);
    setEndTime(newValue[1] + segmentDetails?.video_start_time / 1000);
  };

   const handleResetInterval = () => {
    let s_time = Math.round(currentKeyMoment.start_time / 1000);
    let e_time = Math.round(currentKeyMoment.end_time / 1000);
    setSliderValue([s_time, e_time]);
  };

  const formatIntervalLabel = (value) => {
    if (!value) return "00:00";
    const minutes = Math.floor(value / 60); // Get full minutes
    const seconds = Math.floor(value % 60); // Get remaining seconds

    return `${minutes < 10 ? "0" : ""}${minutes}:${
      seconds < 10 ? "0" : ""
    }${seconds}`;
  };

  const onChangeKeyMoment = (index) => {
    let s_time = Math.floor(
      keyMoments[index].start_time / 1000 +
        segmentDetails?.video_start_time / 1000
    );
    let e_time = Math.floor(
      keyMoments[index].end_time / 1000 +
        segmentDetails?.video_start_time / 1000
    );
    setSliderValue([
      Math.floor(keyMoments[index].start_time / 1000),
      Math.floor(keyMoments[index].end_time / 1000),
    ]);
    setStartTime(s_time);
    setEndTime(e_time);
    setCurrentKeyMoment(keyMoments[index]);
    setPlaying(false);
    setPlaytime(Math.floor(keyMoments[index].start_time / 1000));
  };

   useEffect(() => {
    if (keyMoments?.length > 0) {
      let s_time = Math.floor(
        keyMoments[0].start_time / 1000 +
          segmentDetails?.video_start_time / 1000
      );
      let e_time = Math.floor(
        keyMoments[0].end_time / 1000 + segmentDetails?.video_start_time / 1000
      );
      setCurrentKeyMoment(keyMoments[0]);
      setStartTime(s_time);
      setEndTime(e_time);
      setSliderValue([
        Math.floor(keyMoments[0].start_time / 1000),
        Math.floor(keyMoments[0].end_time / 1000),
      ]);
      setPlaytime(Math.floor(keyMoments[0].start_time / 1000));
    } else {
      setPlaytime(0);
      setStartTime(Math.floor(segmentDetails?.video_start_time / 1000));
      setEndTime(Math.floor(segmentDetails?.video_end_time / 1000));
    }
  }, [keyMoments, segmentDetails]);
  
  return (
    <>
      <Box p={4}>
        <Box
          style={{
            border: "1px solid #AC1FFF",
            padding: 24,
            marginTop: 42,
            borderRadius: 12,
          }}
        >
          <p
            className="alt-clip"
            style={{
              fontFamily: "Roboto Condensed",
              fontSize: 20,
              fontWeight: 600,
              color: "#000000de",
            }}
          >
            {segmentDetails?.headline}
          </p>
          <p className="alt-clip">
            <div className="alt-clip-metadata">
              <CalendarMonth sx={{ verticalAlign: "middle", fontSize: 18 }} />{" "}
              {formattedDate(segmentDetails?.video_timestamp?.epoch_millis)}
            </div>
            <Box mt={2}>
              {isExpanded
                ? segmentDetails?.description
                : segmentDetails?.description?.substring(0, 100) + "...."}
              <Button
                variant="text"
                style={{ padding: "0", textTransform: "none" }}
                onClick={() => setIsExpanded(!isExpanded)}
              >
                {isExpanded ? "See Less" : "See More"}
              </Button>
            </Box>
          </p>
          <Box marginTop={2} display={"flex"} justifyContent={"center"}>
            <HLSPlayer
              streamUrl={videoUrl}
              width="200px"
              height="200px"
              startTime={startTime}
              endTime={endTime}
              playing={playing}
              mute={mute}
              setPlaytime={(val) => {
                setPlaytime(val);
              }}
              handleAutoPause={(val) => {
                setPlaying(false);
              }}
              showControls={false}
            />
          </Box>
          <Card sx={{ width: "100%", marginBottom: "1rem" }}>
            <Box
              sx={{
                padding: "0.2rem 0.3rem",
                display: "flex",
                gap: "1rem",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Box display="flex" alignItems="center" gap="0.5rem">
                {playing ? (
                  <PauseCircleFilledOutlined
                    style={{
                      fontSize: 28,
                      cursor: "pointer",
                    }}
                    onClick={() => setPlaying((val) => !val)}
                  />
                ) : (
                  <PlayCircleFilledOutlined
                    style={{
                      fontSize: 28,
                      cursor: "pointer",
                    }}
                    onClick={() => setPlaying((val) => !val)}
                  />
                )}
                {mute ? (
                  <VolumeOffOutlined
                    onClick={() => setMute((val) => !val)}
                    style={{
                      cursor: "pointer",
                      fill: "#AC1FFF",
                    }}
                  />
                ) : (
                  <VolumeMuteOutlined
                    onClick={() => setMute((val) => !val)}
                    style={{ cursor: "pointer" }}
                  />
                )}
              </Box>
              <Typography variant="caption">
                {formatIntervalLabel(
                  keyMoments?.length > 0 ? sliderValue[0] + playtime : playtime
                ) +
                  "/" +
                  formatIntervalLabel(
                    Math.floor(segmentDetails?.video_duration / 1000)
                  )}
              </Typography>
            </Box>
          </Card>
          {keyMoments?.length > 0 ? (
            <Box>
              <Box style={{ display: "flex" }}>
                <p className="alt-clip-interval-label">Customize Interval:</p>
                <Button
                  onClick={handleResetInterval}
                  variant="outlined"
                  size="small"
                  sx={{
                    fontSize: 13,
                    color: "#666666",
                    borderColor: "#666666",
                    borderRadius: 12,
                    lineHeight: 0,
                    textTransform: "capitalize",
                    fontFamily: "Roboto Condensed",
                    "&:hover": {
                      borderColor: "#666666",
                      color: "#FFFFFF",
                      background: "#666666",
                    },
                  }}
                >
                  Segment
                </Button>
              </Box>
              <Slider
                fullWidth
                valueLabelDisplay="on"
                value={sliderValue}
                valueLabelFormat={(v) => formatIntervalLabel(v)}
                onChange={handleRangeSlider}
                // onChangeCommitted={handleRangeCommitted}
                // min={Math.floor(segmentDetails?.video_start_time / 1000)}
                // max={Math.floor(segmentDetails?.video_end_time / 1000)}
                min={0}
                max={Math.floor(segmentDetails?.video_duration / 1000)}
                step={1}
                sx={{
                  padding: 0,
                  marginBottom: 2,
                  marginTop: 1,
                  "& .MuiSlider-thumb": {
                    backgroundColor: "#ffffff",
                    border: "4px solid #666666",
                    height: 12,
                    width: 12,
                  },
                  "& .MuiSlider-rail": {
                    backgroundColor: "#cccccc",
                  },
                  "& .MuiSlider-track": {
                    backgroundColor: "#666666",
                    border: 0,
                  },
                  "& .MuiSlider-mark": {
                    backgroundColor: "#AC1FFF",
                    height: 8,
                  },
                  "& .MuiSlider-valueLabel": {
                    backgroundColor: "#666666",
                    borderRadius: 12,
                    bottom: -54,
                    paddingTop: "2px",
                    paddingBottom: "2px",
                    top: "auto",
                    fontSize: 12,
                    "&::before": {
                      top: -7,
                      bottom: "auto",
                    },
                  },
                }}
              />
              <Box
                display="flex"
                alignItems="center"
                gap={"0.5rem"}
                maxWidth={"100%"}
                overflow="auto"
              >
                {keyMoments?.length > 0 &&
                  keyMoments.map((keyMoment, index) => {
                    return (
                      <Button
                        size="medium"
                        variant={
                          keyMoment?.description ===
                          currentKeyMoment?.description
                            ? "contained"
                            : "outlined"
                        }
                        // onClick={() => editCurrentClip(currentIndex, clipInterval)}
                        onClick={() => onChangeKeyMoment(index)}
                        startIcon={<SwapHorizOutlined />}
                        sx={{
                          flexShrink: 0,
                          "&:hover": {
                            background: "#AC1FFF",
                            color: "#FFFFFF",
                            border: "1px solid grey",
                          },
                          border: "1px solid grey",
                          borderRadius: 12,
                          fontSize: 13,
                          fontWeight: 700,
                          letterSpacing: "-0.5px",
                          marginTop: 2,
                          marginBottom: 1,
                          background:
                            keyMoment?.start_time ===
                            currentKeyMoment?.start_time
                              ? "#AC1FFF"
                              : "transparent",
                          color:
                            keyMoment?.start_time ===
                            currentKeyMoment?.start_time
                              ? "#FFFFFF"
                              : "#666666",
                          textTransform: "capitalize",
                        }}
                      >
                        Moment {index + 1}
                      </Button>
                    );
                  })}
              </Box>
              <Box mt={1}>
                <Typography
                  className="alt-clip"
                  style={{
                    fontFamily: "Roboto Condensed",
                    // fontSize: 20,
                    color: "#000000de",
                  }}
                >
                  {currentKeyMoment?.description}
                </Typography>
              </Box>
            </Box>
          ) : (
            <Box>
              <Typography
                textAlign="center"
                variant="body1"
                fontFamily={"Roboto Condensed"}
              >
                No Key Moments Available
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
    </>
  );
}
